import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { roundedCount } from "@circle-react/helpers/notificationHelpers";

import type { Tab } from "./NotificationContext";
import { FILTERS, TABS, useNotificationContext } from "./NotificationContext";
import type { NotificationTab } from "./types";
import { useNotificationsCount } from "./useHeaderNotificationsApi";
import { useV2TabsList } from "./useV2TabsList";

export const useNotificationTabs = (): NotificationTab[] => {
  const { activeFilter, getTabLabel, setNotificationTabCounters } =
    useNotificationContext();
  const { currentCommunity } = usePunditUserContext();

  const { data: counters } = useNotificationsCount(
    currentCommunity?.id,
    setNotificationTabCounters,
  );

  const tabsList = useV2TabsList();
  const isActiveFilterArchived = activeFilter === FILTERS.ARCHIVED;

  const countByTab: Partial<Record<Tab, number>> = {
    [TABS.INBOX]: counters?.new_inbox_count ?? 0,
    [TABS.MENTIONS]: counters?.new_mentions_count ?? 0,
    [TABS.CONTENT]: counters?.new_content_count ?? 0,
    [TABS.MODERATION]: counters?.new_moderation_count ?? 0,
  };

  return tabsList.map(tab => {
    const count = countByTab[tab] ?? 0;
    const hasBadge = !isActiveFilterArchived && count > 0;
    return {
      value: tab,
      label: getTabLabel(tab),
      badge: hasBadge ? String(roundedCount(count)) : undefined,
    };
  });
};
